import {
  RESET_FLASH_MSGS,
  RESET_FLASH_MSG,
  RESET_ERROR,
  GET_FLASH_MSGS,
  SET_FLASH_MSGS,
  API_ERROR,
  CREATE_FLASH_MSG,
  CREATE_FLASH_MSG_SUCCESS,
  GET_FLASH_MSG,
  SET_FLASH_MSG,
  EDIT_FLASH_MSG,
  EDIT_FLASH_MSG_SUCCESS,
  DELETE_FLASH_MSG,
  DELETE_FLASH_MSG_SUCCESS,
} from "./actionTypes";

const initialState = {
  errorFlashMsg: false,
  loadingFlashMsg: false,
  dataFlashMsg: null,
  successFlashMsg: false,
};

const FlashMsgs = (state = initialState, action) => {
  switch (action.type) {
    case RESET_FLASH_MSGS:
      state = {
        ...state,
        errorFlashMsg: false,
        loadingFlashMsg: false,
        loadingFlashMsgDelete: false,
        successFlashMsg: false,
        dataFlashMsg: null,
        
      };
      break;
    case RESET_FLASH_MSG:
      state = {
        ...state,
        errorFlashMsg: false,
        loadingFlashMsg: false,
        successFlashMsg: false,
        dataFlashMsgGetSet: null,
        dataFlashMsgEditCreate: null,
        dataFlashMsgDelete: null,
      };
      break;
    case RESET_ERROR:
      state = {
        ...state,
        errorFlashMsg: false,
        loadingFlashMsg: false,
        loadingFlashMsgEditCreate: false,
        loadingFlashMsgActivate: false,
        successFlashMsg: false,
      };
      break;
    case GET_FLASH_MSGS:
      state = {
        ...state,
        errorFlashMsg: false,
        loadingFlashMsg: true,
        dataFlashMsg: null,
      };
      break;
    case SET_FLASH_MSGS:
      state = {
        ...state,
        errorFlashMsg: false,
        loadingFlashMsg: false,
        dataFlashMsg: action.payload,
      };
      break;
    case CREATE_FLASH_MSG:
      state = {
        ...state,
        errorFlashMsg: false,
        loadingFlashMsgEditCreate: true,
        dataFlashMsgEditCreate: action.payload,
        successFlashMsg: false,
      };
      break;
    case CREATE_FLASH_MSG_SUCCESS:
      state = {
        ...state,
        errorFlashMsg: false,
        loadingFlashMsgEditCreate: false,
        dataFlashMsgEditCreate: action.payload.data,
        successFlashMsg: true,
      };
      break;
    case GET_FLASH_MSG:
      state = {
        ...state,
        errorFlashMsg: false,
        loadingFlashMsg: true,
        dataFlashMsgGetSet: null,
      };
      break;
    case SET_FLASH_MSG:
      state = {
        ...state,
        errorFlashMsg: false,
        loadingFlashMsg: false,
        dataFlashMsgGetSet: action.payload,
      };
      break;
    case EDIT_FLASH_MSG:
      state = {
        ...state,
        errorFlashMsg: false,
        loadingFlashMsgEditCreate: true,
        dataFlashMsgEditCreate: action.payload,
        successFlashMsg: false,
      };
      break;
    case EDIT_FLASH_MSG_SUCCESS:
      state = {
        ...state,
        errorFlashMsg: false,
        loadingFlashMsgEditCreate: false,
        dataFlashMsgEditCreate: action.payload,
        successFlashMsg: true,
      };
      break;
    case API_ERROR:
      state = {
        ...state,
        errorFlashMsg: action.payload,
        loadingFlashMsg: false,
        loadingFlashMsgDelete: false,
        successFlashMsg: false,
      };
      break;
    case DELETE_FLASH_MSG:
      state = {
        ...state,
        errorFlashMsg: false,
        loadingFlashMsgDelete: true,
        dataFlashMsgDelete: action.payload,
        successFlashMsg: false,
      };
      break;
    case DELETE_FLASH_MSG_SUCCESS:
      state = {
        ...state,
        errorFlashMsg: false,
        loadingFlashMsgDelete: false,
        dataFlashMsgDelete: action.payload,
        successFlashMsg: true,
      };
      break;
    default:
      // state = { ...state, errorFlashMsg: false, loadingFlashMsg: false };
      break;
  }
  return state;
};

export default FlashMsgs;
